import { DeleteOutlined } from "@ant-design/icons";
import { FC, useCallback } from "react";

import BaseButton from "@/components/BaseButton";
import { BaseModal } from "@/components/BaseModal";
import { useResetApp } from "@/hooks/useResetApp";

interface DayStartedModalProps {
    onClose: () => void;
}

export const DayStartedModal: FC<DayStartedModalProps> = ({ onClose }) => {
    const { handleReset } = useResetApp();

    const handleClickReset = useCallback(() => {
        onClose();
        handleReset();
    }, []);

    return (
        <BaseModal
            title={"День уже розпочато"}
            open
            onClose={onClose}
            actions={null}
            closable={false}
            maskClosable={false}
        >
            <BaseButton
                type="primary"
                icon={<DeleteOutlined />}
                onClick={handleClickReset}
            >
                Скинути кеш
            </BaseButton>

            <BaseButton type="default" onClick={onClose}>
                Повернутися назад
            </BaseButton>
        </BaseModal>
    );
};
